<div
  [attr.data-color]="validColor"
  class="tile-icon"
>
  <div
    [innerHtml]="'<i class=\'fa-regular fa-'+$safeNavigationMigration(appearance?.Icon)+'\'>'"
    class="icon"
  ></div>
</div>
